var map = {
	"./black/setting2.png": "b4G+",
	"./blue/setting2.png": "eFA1",
	"./white/setting2.png": "eGLO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "qoAS";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/setting2\.png$
// module id = qoAS
// module chunks = 24